export default { sha: '4301d856aea64fe893bccfd197b17d8a5a8f4058', buildNumber: 'undefined' }
